module.exports = __webpack_public_path__ + "assets/RetinaNarr-Book.0606fb011eb4f71a05f334a661a66c71.woff2";